module.exports = __webpack_public_path__ + "static/media/cheese-swiss.e6ab945a.svg";